import React, { useEffect, useState } from 'react';
import { onboardingAPI } from '../services/api';
import './OnboardingChecklist.css';

/**
 * In-product onboarding checklist.
 * Fetches the org's setup progress from GET /api/onboarding and renders a
 * dismissible card. Steps advance on their own as the operator uses the product
 * (adds a customer, dispatches a job, connects messaging/payments). Once every
 * step is done the card hides itself.
 */
export default function OnboardingChecklist() {
  const [data, setData] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    onboardingAPI
      .get()
      .then((res) => { if (active) setData(res.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, []);

  if (error || hidden || !data || data.dismissed || data.complete) return null;

  const dismiss = () => {
    setHidden(true);
    onboardingAPI.setDismissed(true).catch(() => {});
  };

  return (
    <div className="onboarding-card" role="region" aria-label="Getting started checklist">
      <div className="onboarding-head">
        <div>
          <h2>Get set up</h2>
          <p>{data.completed} of {data.total} steps done — finish these to run your first jobs.</p>
        </div>
        <button className="onboarding-dismiss" onClick={dismiss} aria-label="Dismiss checklist">×</button>
      </div>

      <div className="onboarding-progress" aria-hidden="true">
        <div className="onboarding-progress-bar" style={{ width: `${data.percent}%` }} />
      </div>

      <ul className="onboarding-steps">
        {data.steps.map((s) => (
          <li key={s.key} className={s.done ? 'done' : ''}>
            <span className="onboarding-check">{s.done ? '✓' : ''}</span>
            <span className="onboarding-step-text">
              <strong>{s.title}</strong>
              <small>{s.desc}</small>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
